<template>
  <div class="checkbox checkbox-custom" :class="{'checkbox-inline' : inline === 1}">
    <label>
      <input :name="id" :id="id" type="checkbox" :checked="value" :value="val" @change="triggerEvent"> 
      <span class="checkbox-custom-btn"></span>
      <slot></slot>
      <span v-if="aria" class="sr-only">{{aria}}</span>
    </label>
      <div  v-if="modal"><a href="#" data-bs-toggle="modal" :data-bs-target="modalId" ><span v-html="$t('ic_wiecej_info_rodo')"></span></a></div>
  </div>
</template>

<script>
export default {
  name: "IcCheckbox",
  props: {
    id : {type: String, required: true},
    modalId : {type: String},
    modal : {type: Boolean, default: false},
    value : {type: [String, Number, Boolean], required: true},
    val : {type: [String, Number], required: true},
    // name : {type: String, required: true},
    v : {},
    inline: {type: Number, default: 0},
    aria: {type: String, required: false}
  },
  methods: {
      triggerEvent(event) {
        this.$emit('input', event.target.checked ? event.target.value : '')
        if (this.v) {
          this.v.$touch()
        }
      }
    }
};
</script>
 
<style>
  .has-error .checkbox-custom {
    color: #ed1c24;
  }
</style>
